import { REMOVE_FEATURE, RESET_VECTOR_REMOVE_FEATURE } from '../actions/geoJsonActions';

const initialeState = {
    vectorAddFeature : null,
    vectoreRemoveFeature: null,
    ParcellesGeoCollection: {
        'type': 'geojson',
        'data': {
            'type': 'FeatureCollection',
            'features': []
        }}

}


const GeoJsonReducer = (state = initialeState, action) => {
    switch (action.type) {
        case 'ADD_FEATURE':
            return {
                ...state,
                vectorData: action.data.geoJson
            }
        case 'REMOVE_FEATURE':
            return {
                ...state,
                vectoreRemoveFeature: action.data.featureId,
            }
        case 'RESET_VECTOR_REMOVE_FEATURE':
            return {
                ...state,
                vectoreRemoveFeature: null,
            }
        case 'UPDATE_PARCELLES_FEATURES_COLLECTION':
            return {
                ...state,
                ParcellesGeoCollection: action.data.geoJsonFeatureCollection
            }
        default:
            return state
    }
}

export default GeoJsonReducer
